import React from 'react';

const InstagramIcon: React.FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
        <defs>
            <style>
                {`.iconinsta-1{fill:none;}`}
            </style>
        </defs>
        <g id="Capa_2" data-name="Capa 2">
            <g id="Capa_1-2" data-name="Capa 1">
                {/* Cambia 'class' a 'className' aquí y en cualquier otro lugar donde uses clases CSS en SVG */}
                <rect className="iconinsta-1" width="50" height="50"></rect>
                <path d="M36.47,0H13.53A13.55,13.55,0,0,0,0,13.53V36.47A13.55,13.55,0,0,0,13.53,50H36.47A13.55,13.55,0,0,0,50,36.47V13.53A13.55,13.55,0,0,0,36.47,0Zm10.6,36.47a10.62,10.62,0,0,1-10.6,10.6H13.53a10.62,10.62,0,0,1-10.6-10.6V13.53a10.62,10.62,0,0,1,10.6-10.6H36.47a10.62,10.62,0,0,1,10.6,10.6ZM25,11.33A13.67,13.67,0,1,0,38.67,25,13.68,13.68,0,0,0,25,11.33Zm0,24.41A10.74,10.74,0,1,1,35.74,25,10.75,10.75,0,0,1,25,35.74ZM39,6.47a4,4,0,1,0,4,4,4,4,0,0,0-4-4Zm0,5.15a1.11,1.11,0,1,1,1.11-1.11A1.11,1.11,0,0,1,39,11.62Z"></path>
            </g>
        </g>
    </svg>
);

export default InstagramIcon;